import { useEffect, useState } from 'react';
import aboutLogo from '../../asset/aboutImage.png';
import { Link } from 'react-router-dom';
import applications from '../../data/applications'; // Update the path according to your project structure

function Applications() {
  const [isMobile, setIsMobile] = useState(window.innerWidth > 750);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth > 750);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className='home'>
      <div className='d-flex flex-wrap justify-content-center align-items-center about-top pb-5'>
        <div>
          <h1 style={{ fontSize: isMobile ? "60px" : "40px" ,paddingTop:isMobile ? "10px" : "70px"}} className='sub-title'>Applications</h1>
        </div>

        {applications.map(app => (
  <div key={app.id} className='d-flex flex-wrap justify-content-center align-items-center pt-2 pb-5'>
    {app.id % 2 !== 0 ? (
      <>
        {/* Text column */}
        <div className={`col-md-6 col-12 d-flex flex-column justify-content-center align-items-center`}>
          <div className='p py-5 d-flex flex-column w-75'>
            <h1 style={{ fontSize: isMobile ? "60px" : "30px", letterSpacing: "5px" }} className='home-title'>{app.name}</h1>
            <p>{app.description}</p>
          </div>
        </div>
        {/* Image column */}
        <div className={`col-md-6 col-12 d-flex justify-content-center align-items-center`}>
          <img src={app.image} style={{ width: '65%' }} alt={app.name} />
        </div>
      </>
    ) : (
      <>
        {/* Image column */}
        <div className={`col-md-6 col-12 d-flex justify-content-center align-items-center order-md-1 order-2`}>
          <img src={app.image} style={{ width: '65%' }} alt={app.name} />
        </div>
        {/* Text column */}
        <div className={`col-md-6 col-12 d-flex flex-column justify-content-center align-items-center order-md-2 order-1`}>
          <div className='p py-5 d-flex flex-column w-75'>
            <h1 style={{ fontSize: isMobile ? "60px" : "30px", letterSpacing: "5px" }} className='home-title'>{app.name}</h1>
            <p>{app.description}</p>
          </div>
        </div>
      </>
    )}
  </div>
))}
      </div>
    </div>
  );
}

export default Applications;
